import { motion } from 'framer-motion'
import { useEffect, useState } from 'react'
import { useI18n } from '../lib/i18n'
import { Wordmark } from './Wordmark'
import { Button } from './Button'
import { ease } from '../lib/motion'

const LINKS = [
  { href: '/app/carbon-map', key: 'nav.carbon' },
  { href: '#problem', key: 'nav.problem' },
  { href: '#solution', key: 'nav.solution' },
  { href: '#how', key: 'nav.how' },
  { href: '#products', key: 'nav.products' },
  { href: '#news', key: 'nav.news' },
]

export function Nav() {
  const { t, lang, setLang } = useI18n()
  const [solid, setSolid] = useState(false)
  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 40)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <motion.nav
      className={`nav ${solid ? 'nav--solid' : ''}`}
      initial={{ y: -64, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: ease.out as unknown as number[] }}
    >
      <div className="nav-in container">
        <a className="nav-brand" href="#top" aria-label="ARGO">
          <Wordmark size={24} />
          <span className="nav-engine tag">EUDR ENGINE</span>
        </a>
        <div className="nav-links">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href}>{t(l.key)}</a>
          ))}
        </div>
        <div className="nav-cta">
          <div className="lang-toggle" role="group" aria-label="Language">
            <button className={`lang-btn ${lang === 'vi' ? 'is-active' : ''}`} onClick={() => setLang('vi')} aria-pressed={lang === 'vi'}>VI</button>
            <button className={`lang-btn ${lang === 'en' ? 'is-active' : ''}`} onClick={() => setLang('en')} aria-pressed={lang === 'en'}>EN</button>
          </div>
          <Button variant="primary" href="/app">{t('nav.cta')}</Button>
        </div>
      </div>
    </motion.nav>
  )
}
